export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/guest/index/resources/computed.js